import { render, staticRenderFns } from "./ReproductorVideo.vue?vue&type=template&id=354b7799"
import script from "./ReproductorVideo.vue?vue&type=script&lang=js"
export * from "./ReproductorVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports